import { makeStyles } from 'tss-react/mui';

const useStylesSearchQuickMenu: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme,
): MaterialUIStyles => ({
  searchQuickMenu: {
    maxHeight: '250px !important',
    width: 292,
    top: '52px !important',
    marginLeft: 7,
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 32px)',
      top: '67px !important',
      marginLeft: 0,
    },
    [theme.breakpoints.down('sm')]: {
      top: '195px !important',
      width: 'calc(100vw - 75px)',
    },
  },
  searchQuickMenuItemTextName: {
    maxWidth: 'calc(100% - 65px)',
    overflowX: 'hidden !important',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export default useStylesSearchQuickMenu;
